function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//

import { Local } from '@/utils/storage.js';
import { mapMutations } from 'vuex';
import { getNewTagList } from '@/utils/util';
import { orderListApi } from '@/api/order';
import Cookies from 'js-cookie';
export default {
  name: 'layout',
  components: {
    Defaults: function Defaults() {
      return import('@/layout/main/defaults.vue');
    },
    Classic: function Classic() {
      return import('@/layout/main/classic.vue');
    },
    Transverse: function Transverse() {
      return import('@/layout/main/transverse.vue');
    },
    Columns: function Columns() {
      return import('@/layout/main/columns.vue');
    },
    Mains: function Mains() {
      return import('@/layout/component/main.vue');
    }
  },
  data: function data() {
    return {
      headMenuNoShow: false,
      orderRemindTimer: null,
      orderRemindLastOrderNo: '',
      orderRemindBaselineReady: false,
      orderRemindToggleHandler: null
    };
  },
  computed: {
    // 获取布局配置信息
    getThemeConfig: function getThemeConfig() {
      return this.$store.state.themeConfig.themeConfig;
    },
    tagNavList: function tagNavList() {
      return this.$store.state.menu.tagNavList;
    },
    routesList: function routesList() {
      return this.$store.state.user.menuList;
    }
  },
  watch: {
    $route: function $route(newRoute) {
      var name = newRoute.name,
        query = newRoute.query,
        params = newRoute.params,
        meta = newRoute.meta,
        path = newRoute.path;
      this.addTag({
        route: {
          name: name,
          query: query,
          params: params,
          meta: meta,
          path: path
        },
        type: 'push'
      });
      this.setBreadCrumb(newRoute);
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute));
    }
  },
  created: function created() {
    this.onLayoutResize();
    window.addEventListener('resize', this.onLayoutResize);
  },
  mounted: function mounted() {
    var _this = this;
    this.startOrderRemind();
    this.orderRemindToggleHandler = function () {
      return _this.startOrderRemind();
    };
    this.bus.$on('orderRemindToggle', this.orderRemindToggleHandler);
    this.requestNotificationPermission();
  },
  beforeDestroy: function beforeDestroy() {
    this.stopOrderRemind();
    if (this.orderRemindToggleHandler) {
      this.bus.$off('orderRemindToggle', this.orderRemindToggleHandler);
      this.orderRemindToggleHandler = null;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('menu', ['setBreadCrumb', 'setTagNavList', 'addTag', 'setLocal', 'setHomeRoute', 'closeTag'])), {}, {
    // 窗口大小改变时(适配移动端)
    onLayoutResize: function onLayoutResize() {
      if (!Local.get('oldLayout')) Local.set('oldLayout', this.$store.state.themeConfig.themeConfig.layout);
      var clientWidth = document.body.clientWidth;
      if (clientWidth < 1000) {
        this.$store.state.themeConfig.themeConfig.isCollapse = false;
        this.bus.$emit('layoutMobileResize', {
          layout: 'defaults',
          clientWidth: clientWidth
        });
      } else {
        this.bus.$emit('layoutMobileResize', {
          layout: Local.get('oldLayout') ? Local.get('oldLayout') : this.$store.state.themeConfig.themeConfig.layout,
          clientWidth: clientWidth
        });
      }
    },
    // 开启下单语音播报轮询
    startOrderRemind: function startOrderRemind() {
      var _this2 = this;
      this.stopOrderRemind();
      this.orderRemindLastOrderNo = '';
      this.orderRemindBaselineReady = false;
      if (Cookies.get('merVoiceRemind') !== '1') return;
      this.checkNewOrder();
      this.orderRemindTimer = setInterval(function () {
        _this2.checkNewOrder();
      }, 5000);
    },
    // 停止下单语音播报轮询
    stopOrderRemind: function stopOrderRemind() {
      if (this.orderRemindTimer) {
        clearInterval(this.orderRemindTimer);
        this.orderRemindTimer = null;
      }
    },
    // 检查是否有新订单
    checkNewOrder: function checkNewOrder() {
      var _this3 = this;
      orderListApi({
        status: 'notShipped',
        page: 1,
        limit: 1
      }).then(function (res) {
        var list = res && res.list || [];
        var latest = list[0];
        var latestOrderNo = latest ? latest.orderNo : '';
        if (!_this3.orderRemindBaselineReady) {
          // 首次仅记录，避免登录即播报历史订单
          _this3.orderRemindLastOrderNo = latestOrderNo;
          _this3.orderRemindBaselineReady = true;
          return;
        }
        if (latestOrderNo && latestOrderNo !== _this3.orderRemindLastOrderNo) {
          _this3.orderRemindLastOrderNo = latestOrderNo;
          _this3.speakOrderRemind();
          _this3.showDesktopNotification(latestOrderNo);
          _this3.$notify.info({
            title: '新订单提醒',
            message: "\u60A8\u6709\u65B0\u7684\u8BA2\u5355\uFF0C\u8BA2\u5355\u53F7\uFF1A".concat(latestOrderNo),
            duration: 6000
          });
        }
      }).catch(function () {});
    },
    // 语音播报新订单
    speakOrderRemind: function speakOrderRemind() {
      try {
        if (!('speechSynthesis' in window)) return;
        var utterance = new SpeechSynthesisUtterance('您有新的订单，请及时处理');
        utterance.lang = 'zh-CN';
        utterance.rate = 1;
        window.speechSynthesis.cancel();
        window.speechSynthesis.speak(utterance);
      } catch (e) {
        // 忽略语音播报异常
      }
    },
    // 发送桌面通知
    showDesktopNotification: function showDesktopNotification(orderNo) {
      try {
        if (!('Notification' in window) || Notification.permission !== 'granted') return;
        new Notification('新订单提醒', {
          body: "\u60A8\u6709\u65B0\u7684\u8BA2\u5355\uFF0C\u8BA2\u5355\u53F7\uFF1A".concat(orderNo)
        });
      } catch (e) {
        // 忽略桌面通知异常
      }
    },
    // 请求桌面通知权限（需用户手势触发）
    requestNotificationPermission: function requestNotificationPermission() {
      try {
        if (!('Notification' in window) || Notification.permission !== 'default') return;
        var _request = function request() {
          window.removeEventListener('click', _request);
          window.removeEventListener('keydown', _request);
          Notification.requestPermission();
        };
        window.addEventListener('click', _request);
        window.addEventListener('keydown', _request);
      } catch (e) {
        // 忽略通知权限请求异常
      }
    }
  }),
  distroyed: function distroyed() {
    window.removeEventListener('resize', this.onLayoutResize);
  }
};